<div class="admin-page-layout-container">
    <tam-splitter splitterBarWidth=3 [direction]="'horizontal'" [useTransition]="300">
        <tam-splitter-panel [size]="15" [max]="15" [min]="15">
            <div class="list-container" tid="side-note-list-panel">
                <div class="tool-bar">
                    <div class="search-box">
                        <aacl-keyword-search [options]="keywordSearchOptions"></aacl-keyword-search>
                    </div>
                </div>
                <div class="list-pane">
                    <div class="thread-list">
                        <div *ngFor="let page of (pages | adminPageFilter: keyword)">
                            <span class="group-title">{{page[0]}}</span>
                            <div *ngFor="let item of page[1]" class="item" (click)="onPageClick(item)"
                                [ngClass]="{'active':selectedPage===item}">
                                <div class="item-container">{{ item.id ? item.id: '' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </tam-splitter-panel>
        <tam-splitter-panel [size]="85" [max]="150" [min]="30">
            <router-outlet></router-outlet>
        </tam-splitter-panel>
    </tam-splitter>
</div>